import { useSelector } from "react-redux"

const useCompetitions = () => {
  const competitions = useSelector(state => 
    state.organization.organization && 
    state.organization.organization.competitions)
  return competitions || {}
}

export default useCompetitions